export const FINANCIAL_DETAILS_FIELDS_MAX = {
  MONTHLY_GROSS_INCOME: 149999,
  MONTHLY_HOUSE_COST: 49999,
  TRANSPORTATION_COST: 19999,
  OTHER_LOAN_COST: 49999,
};

export const Campaigns = {
  ID_PROTECT_2_MONTHS_FREE: 'ID_PROTECT_2_MONTHS_FREE',
} as const;

export type CampaignName = (typeof Campaigns)[keyof typeof Campaigns];
